<h3>Qu’est-ce que le Nutri-Score ?</h3>
<p>
  Le Nutri-Score est un logo qui vous informe sur la qualité nutritionnelle d’un produit ou d’une recette, en le positionnant sur une échelle à 5 niveaux
  associant des lettres à des couleurs.
</p>

<div class="nutriscore">
  <div class="nutriscore-picto">
    <ion-icon src="/assets/svg/dish/nutriscore/nutriscore-A.svg"></ion-icon>
  </div>
  <div>A pour les recettes les plus favorables sur le plan nutritionnel</div>
</div>
<div class="nutriscore">
  <div class="nutriscore-picto">
    <ion-icon src="/assets/svg/dish/nutriscore/nutriscore-E.svg"></ion-icon>
  </div>
  <div>E pour les recettes les moins favorables sur le plan nutritionnel</div>
</div>

<h3>Comment le Nutri-Score est-il calculé ?</h3>
<p>
  Le calcul du Nutri-Score a été mis au point par des scientifiques, des médecins et des nutritionnistes. Il tient compte, pour 100g d’aliments, de la teneur :
</p>
<ul>
  <li>
    - En nutriments et aliments à favoriser : fibres, protéines, fruits et légumes, légumineuses, fruits à coque et huiles végétales (olive, colza et noix),
  </li>
  <li>- En énergie et nutriments à limiter : calories, acides gras saturés, sucres, sel.</li>
</ul>
<h3>Quelle est la finalité du Nutri-Score ?</h3>
<ul>
  <li>- Offrir grâce à sa simplicité et son caractère intuitif, une réelle transparence sur la qualité globale de nos recettes,</li>
  <li>- Améliorer nos recettes (moins de sel, de gras, de sucre, plus de fibres…),</li>
  <li>- Vous permettre de choisir plus facilement les aliments de meilleure qualité nutritionnelle,</li>
  <li>- Améliorer la compréhension de la qualité nutritionnelle de l’offre proposée.</li>
</ul>
<h3>Et concrètement, ça change quoi pour vous ?</h3>
<p>
  Le Nutri-Score permet de comparer facilement la qualité nutritionnelle de produits ou recettes d’une même catégorie. L’objectif est d’équilibrer votre plateau
  sur la semaine en privilégiant les plats notés A ou B sans pour autant exclure les plats notés D ou E.
</p>
<footer>
  <p>LE CHOIX DE BIEN MANGER AU QUOTIDIEN !</p>
  <p>Une alimentation variée et équilibrée aide à rester en bonne santé.</p>
</footer>
